import React from 'react';

import { ModalHeader } from './ModalHeader';
import { ModalHorizontalHeader } from './ModalHorizontalHeader';
import { ModalContent } from './modalStyle';

interface IProps {
  title: string;
  subtitle?: string | JSX.Element;
  logoPath?: string;
  closeModal?: () => void;
  children?: React.ReactNode | React.ReactNode[];
  hasContent?: boolean;
  horizontal?: boolean;
  flexHeader?: number;
  height?: number;
  backgroundColor?: string;
}

const ModalView = ({
  title,
  subtitle,
  logoPath,
  closeModal,
  children,
  hasContent = true,
  horizontal = false,
  flexHeader,
  height,
  backgroundColor,
}: IProps) => {
  const ModalHeaderComponenet = horizontal ? ModalHorizontalHeader : ModalHeader;

  return (
    <ModalContent horizontal={horizontal} backgroundColor={backgroundColor}>
      <ModalHeaderComponenet
        title={title}
        subtitle={subtitle}
        logoPath={logoPath}
        closeModal={closeModal}
        hasContent={hasContent}
        flex={flexHeader}
        height={height}
      />

      {children}
    </ModalContent>
  );
};

export default ModalView;
